import clsx from 'clsx';

import { openNewWindow } from '@/lib/webview';

const variants = {
  primary: 'border-blue bg-blue text-white hover:border-blue-d1 hover:bg-blue-d1',
  light: 'border-black bg-white text-black hover:border-black hover:bg-black hover:text-white',
};

export type LinkButtonProps = {
  text: string;
  href: string;
  variant?: keyof typeof variants;
};

export const LinkButton = ({ text, href, variant = 'primary' }: LinkButtonProps) => {
  return (
    <button
      type="button"
      onClick={() => openNewWindow(href)}
      className={clsx(
        'inline-block min-w-[180px] rounded-[50rem] border-[1px] border-solid py-[0.375rem] px-3 text-center text-base shadow-[0_8px_16px_0px_rgba(0,0,0,0.15)] transition-[color,background-color,box-shadow]',
        variants[variant]
      )}
    >
      {text}
    </button>
  );
};
